/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudentList
 *
 * @file StudentList.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  List,
  ListItem,
  Typography,
  Button
} from '@material-ui/core';

import StudentListStyles from './styles/StudentListStyles';

const StudentList = ({
  students,
  selectedStudent,
  onSelect
}) => {
  const classes = StudentListStyles();

  const renderListItem = (item) => {
    if (!item) {
      return null;
    }

    const isSelected = selectedStudent.id === item.id;

    return (
      <ListItem
        key={item.id}
        className={`${classes.listItem} ${
          isSelected ? classes.listItemActive : ''
        }`}
      >
        <Button className={classes.action} onClick={() => onSelect(item)}>
          <div className={classes.detailwrapper}>
            <Typography className={classes.mainText}>{item.name}</Typography>
            <Typography className={classes.labelText}>
              {item.completedAssignments} / {item.totalAssignments} assignments completed
            </Typography>
          </div>
          <div className={`${classes.badge} ${classes[item.status]}`}>
            {item.status}
          </div>
        </Button>
      </ListItem>
    );
  };

  const renderList = () => {
    if (!students || students.length <= 0) {
      return null;
    }

    return (
      <List classes={{ root: classes.root }}>
        {students.map((item) => (
          renderListItem(item)
        ))}
      </List>
    );
  };

  return (
    <div style={{ width: '100%' }}>
      {renderList()}
    </div>
  );
};

StudentList.propTypes = {
  students: PropTypes.array,
  selectedStudent: PropTypes.object,
  onSelect: PropTypes.func
};

StudentList.defaultProps = {
  students: [],
  selectedStudent: {},
  onSelect: () => {}
};

export default StudentList;

